<template>
  <title>{{ informations.title }}</title>
  <link
    rel="icon"
    type="image/jpg"
    :href="'https://admin.asso-refuge.fr/images/' + informations.logo"
  />

  <div class="fixedtoi">
    <header>
      <i class="fas fa-envelope"></i> fa.contact06@gmail.com &nbsp;&nbsp;&nbsp;&nbsp;
    </header>

    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="navbar-container container-fluid">

        <a class="navbar-brand" href="/">
          <img
            :src="'https://admin.asso-refuge.fr/images/' + informations.logo"
            :alt="informations.title"
            width="75px"
          />
          {{ informations.title }}
        </a>

        <div :class="['collapse', 'navbar-collapse', { show: !isCollapsed }]" id="navbarNav">
          <div class="navbar-nav">

            <!-- Qui sommes nous -->
            <router-link
              class="nav-link"
              :to="{ path: '/qui-somme-nous', hash: '#refuge' }"
              @click="toggleNavbar"
            >
              Qui sommes-nous
            </router-link>

            <!-- Pages dynamiques -->
            <template v-for="page in pages" :key="page.id">
              <router-link
                class="nav-link"
                :to="'/' + (page.path_website ? page.path_website : page.path)"
                @click="toggleNavbar"
              >
                {{ page.name }}
              </router-link>
            </template>

            <!-- Événements SUPPRIMÉ -->

          </div>
        </div>

        <button
          class="navbar-toggler"
          type="button"
          aria-controls="navbarNav"
          :aria-expanded="!isCollapsed"
          aria-label="Toggle navigation"
          @click="toggleNavbar"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
    </nav>
  </div>

  <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {
      pages: [],
      informations: {},
      isCollapsed: true,
    };
  },

  mounted() {
    const idSite = this.$idSite;

    fetch(`https://admin.asso-refuge.fr/getPages/${idSite}`)
      .then((response) => response.json())
      .then((data) => {
        let pagesModifiees = data.map((page) => {
          const newPage = { ...page };

          // Modifications demandées
          if (newPage.name === "Nos Animaux") newPage.name = "À l'adoption";
          if (newPage.name === "Bénévole") newPage.name = "Législation animale";
          if (newPage.name === "Combat") newPage.name = "Nos combats";
          if (newPage.name === "Parrainage") newPage.name = "Nos combats";
          if (newPage.name === "Devenir bénévole ou FA") newPage.name = "La législation animale";

          // Logique existante conservée
          if (newPage.path === "services") newPage.path = "tarifs";
          if (newPage.path_website === "services") newPage.path_website = "tarifs";
          if (newPage.name === "Nos services") newPage.name = "Participation €";

          if (newPage.path === "parrainage") newPage.path = "combats";
          if (newPage.path_website === "parrainage") newPage.path_website = "combats";


          return newPage;
        });

        // Réorganisation : "Les adoptés" avant "Nos besoins"
        const adoptesIndex = pagesModifiees.findIndex(p => p.name === "Les adoptés");
        const besoinsIndex = pagesModifiees.findIndex(p => p.name === "Nos besoins");

        if (adoptesIndex !== -1 && besoinsIndex !== -1 && adoptesIndex > besoinsIndex) {
          const adoptes = pagesModifiees.splice(adoptesIndex, 1)[0];
          pagesModifiees.splice(besoinsIndex, 0, adoptes);
        }

        this.pages = pagesModifiees;
      })
      .catch((error) => {
        console.error("Erreur requête pages:", error.message);
      });

    fetch(`https://admin.asso-refuge.fr/getInformations/${idSite}`)
      .then((response) => response.json())
      .then((data) => {
        this.informations = data[0] || {};
      })
      .catch((error) => {
        console.error("Erreur requête infos:", error.message);
      });
  },

  methods: {
    toggleNavbar() {
      this.isCollapsed = !this.isCollapsed;
    },
  },
};
</script>

<style src="../assets/css/refonte.css"></style>
